// extracted by mini-css-extract-plugin
export default {"root":"ProductDetailPage_root__GVXXI","card":"ProductDetailPage_card__I1yL6","clientDisplay":"ProductDetailPage_clientDisplay__pGtay"};